/* eslint-disable max-len*/
import thumbnail0 from './imgs/poster-0.jpg';
import thumbnail1 from './imgs/poster-1.jpg';
import thumbnail2 from './imgs/poster-2.jpg';
import thumbnail3 from './imgs/poster-3.jpg';
import thumbnail4 from './imgs/poster-4.jpg';
import thumbnail5 from './imgs/poster-5.jpg';
import thumbnail6 from './imgs/poster-6.jpg';
import thumbnail7 from './imgs/poster-7.jpg';
import thumbnail8 from './imgs/poster-8.jpg';
import thumbnail9 from './imgs/poster-9.jpg';
import thumbnail10 from './imgs/poster-10.jpg';
import thumbnail11 from './imgs/poster-11.jpg';
import TIME_URL from '../../../imgs/share-poster-time.svg';
import poster2Location from '../../../imgs/poster-2-location.svg';
import poster4Location from '../../../imgs/poster-4-location.svg';
import poster2Time from '../../../imgs/poster2-time.svg';
import poster4Time from '../../../imgs/poster4-time.svg';

export const LOGO_IMG_SRC_WHITE =
  'https://cdn.calendar.tencent.com/calendar_res/canvas/logo-event-white.svg';
export const LOGO_IMG_SRC_DARK =
  'https://cdn.calendar.tencent.com/calendar_res/canvas/logo-event-dark.svg';
export const LOGO_IMG_SRC_WHITE2 =
  'https://cdn.calendar.tencent.com/calendar_res/canvas/logo-event-white2.png';

const getIcon = (src: string) => (
  <img className="icon" crossOrigin="anonymous" src={src} draggable={false} />
);
// 底部二维码组件样式
const QRCODETYPES = {
  TYPE0: 0,
  TYPE1: 1,
  TYPE2: 2,
  TYPE3: 3,
  TYPE4: 4,
  TYPE5: 5,
};
const logoWithSrcWhite = { show: true, src: LOGO_IMG_SRC_WHITE };
const logoWithSrcDark = { show: true, src: LOGO_IMG_SRC_DARK };
const logoHidden = { show: false };
const logoWithSrcWhite2 = { show: true, src: LOGO_IMG_SRC_WHITE2 };
const hostConfigWithLine1 = { show: true, line: 1 };
const hostConfigWithLine2 = { show: true, line: 2 };
const hostConfigWithExtra = { show: true, line: 2, extra: '主办方' };

const timeConfigWithExtra1 = { show: true, extra: '时间' };
const timeConfigWithExtra2 = { show: true, extra: '活动时间' };
const timeConfigWithTrue = { show: true };

const locationConfigWithExtra1 = { show: true, line: 2, extra: '地址' };
const locationConfigWithExtra2 = { show: true, line: 2, extra: '活动地址' };
const locationConfigWithLine3 = { show: true, line: 3 };

const qrcodeConfigType4 = { type: QRCODETYPES.TYPE4 };
const qrcodeConfigType5 = { type: QRCODETYPES.TYPE5 };

const posterConfigs = [
  [
    logoWithSrcWhite2,
    2,
    hostConfigWithLine1,
    true,
    { show: true, extra: getIcon(TIME_URL) },
    { show: false },
    { type: QRCODETYPES.TYPE0 },
    thumbnail0,
  ], // 海报0 默认海报
  [
    logoWithSrcWhite,
    2,
    hostConfigWithLine2,
    true,
    timeConfigWithExtra1,
    locationConfigWithExtra1,
    { type: QRCODETYPES.TYPE1 },
    thumbnail1,
  ], // 海报1
  [
    logoHidden,
    2,
    hostConfigWithLine1,
    true,
    { show: true, extra: getIcon(poster2Time) },
    { show: true, line: 2, extra: getIcon(poster2Location) },
    { type: QRCODETYPES.TYPE2, logo: LOGO_IMG_SRC_DARK },
    thumbnail2,
  ], // 海报2
  [
    logoHidden,
    2,
    hostConfigWithLine1,
    true,
    timeConfigWithExtra1,
    locationConfigWithExtra1,
    { type: QRCODETYPES.TYPE3, logo: LOGO_IMG_SRC_WHITE },
    thumbnail3,
  ], // 海报3
  [
    logoWithSrcWhite,
    2,
    hostConfigWithLine2,
    true,
    { show: true, extra: getIcon(poster4Time) },
    { show: true, line: 2, extra: getIcon(poster4Location) },
    qrcodeConfigType4,
    thumbnail4,
  ], // 海报4
  [
    logoWithSrcDark,
    2,
    hostConfigWithLine2,
    false,
    timeConfigWithExtra2,
    locationConfigWithExtra2,
    qrcodeConfigType4,
    thumbnail5,
  ], // 海报5
  [
    logoWithSrcDark,
    2,
    hostConfigWithLine1,
    false,
    timeConfigWithTrue,
    locationConfigWithLine3,
    qrcodeConfigType4,
    thumbnail6,
  ], // 海报6
  [
    logoWithSrcDark,
    2,
    hostConfigWithLine1,
    false,
    timeConfigWithTrue,
    locationConfigWithLine3,
    qrcodeConfigType4,
    thumbnail7,
  ], // 海报7
  [
    logoWithSrcDark,
    2,
    hostConfigWithLine1,
    false,
    timeConfigWithTrue,
    locationConfigWithLine3,
    qrcodeConfigType4,
    thumbnail8,
  ], // 海报8
  [
    logoWithSrcDark,
    3,
    hostConfigWithExtra,
    false,
    timeConfigWithExtra2,
    locationConfigWithExtra2,
    qrcodeConfigType5,
    thumbnail9,
  ], // 海报9
  [
    logoWithSrcDark,
    3,
    hostConfigWithExtra,
    false,
    timeConfigWithExtra2,
    locationConfigWithExtra2,
    qrcodeConfigType5,
    thumbnail10,
  ], // 海报10
  [
    logoWithSrcDark,
    3,
    hostConfigWithExtra,
    false,
    timeConfigWithExtra2,
    locationConfigWithExtra2,
    qrcodeConfigType5,
    thumbnail11,
  ], // 海报11
];

const genPosterConfigList = () =>
  posterConfigs.map((item, index) => {
    const [
      logoConfig,
      titleLine,
      hostConfig,
      coverShow,
      timeConfig,
      locationConfig,
      qrcodeConfig,
      thumbnail,
    ] = item;
    return {
      logo: logoConfig,
      title: {
        line: titleLine,
      },
      host: hostConfig,
      cover: coverShow,
      time: timeConfig,
      location: locationConfig,
      qrcode: qrcodeConfig,
      posterId: index,
      thumbnail,
    };
  });

const POSTER_CONFIG_LIST = genPosterConfigList();
export default POSTER_CONFIG_LIST;
